import { c as _c } from "react/compiler-runtime";
import { HStack, Icon, Text } from '@chakra-ui/react';
import { formatSessionReviewAverage, hasSessionReviews, sessionReviewCountLabel } from '@src/components/sco/Advisors/reviews/sessionReviewHelpers';
import { LuStar } from 'react-icons/lu';
export type SessionReviewSummaryProps = {
  /** `ScoSessionReviewSummary.averageScore` (both sources, hidden reviews included). */
  averageScore?: number | null;
  /** `ScoSessionReviewSummary.count`. Renders nothing at 0 (L41: shown from 1 review). */
  count?: number | null;
  /** `sm` for directory cards, `md` for the profile header. */
  size?: 'sm' | 'md';
};

/** One star, the average and the review count, e.g. "★ 4.8 · 12 reviews". */
export const SessionReviewSummary = t0 => {
  const $ = _c(20);
  const {
    averageScore,
    count,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  if (!hasSessionReviews({
    count
  })) {
    return null;
  }
  let t2;
  if ($[0] !== averageScore) {
    t2 = formatSessionReviewAverage(averageScore);
    $[0] = averageScore;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const average = t2;
  let t3;
  if ($[2] !== count) {
    t3 = sessionReviewCountLabel(count);
    $[2] = count;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const countLabel = t3;
  const fontSize = size === "sm" ? "xs" : "sm";
  const t4 = average ? `Rated ${average} out of 5 from ${countLabel}` : countLabel;
  const t5 = size === "sm" ? "3.5" : "4";
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      "& path, & polygon": {
        fill: "currentColor"
      }
    };
    t7 = <LuStar />;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t5) {
    t8 = <Icon aria-hidden={true} boxSize={t5} color="orange.fg" css={t6}>{t7}</Icon>;
    $[6] = t5;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== average || $[9] !== fontSize) {
    t9 = average && <Text fontSize={fontSize} fontWeight="semibold">{average}</Text>;
    $[8] = average;
    $[9] = fontSize;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = average ? "\xB7 " : "";
  let t11;
  if ($[11] !== countLabel || $[12] !== fontSize || $[13] !== t10) {
    t11 = <Text color="fg.muted" fontSize={fontSize}>{t10}{countLabel}</Text>;
    $[11] = countLabel;
    $[12] = fontSize;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t4 || $[17] !== t8 || $[18] !== t9) {
    t12 = <HStack aria-label={t4} data-testid="session-review-summary" gap={1} role="group">{t8}{t9}{t11}</HStack>;
    $[15] = t11;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};